<style src="./NewUser.scss" lang="scss" scoped></style>
<template lang="html">
  <section class="new-user">
    <form
      @submit.prevent="submitForm"
      class="row">

      <textbox
        class="col-12"
        label="Nome do usuário"
        placeholder="Ex.: João Alberto de Almeida"
        v-model="form.name" />

      <textbox
        label="Apelido de identificação"
        placeholder="Ex.: JoãoAlberto"
        class="col-12"
        v-model="form.username" />

      <password
        label="Senha"
        placeholder="Ex.: @Ghfg!@"
        class="col-12"
        v-model="form.password" />

      <dropdown
        label="Permissão"
        placeholder="Escolha..."
        v-model="form.permission"
        class="col-12"
        :list-data="listPermissions"/>

      <dropdown
        label="Ocupação"
        placeholder="Escolha..."
        v-model="form.occupation"
        class="col-12"
        :list-data="listOccupations"/>
      
      <stage-checker
        class="col-12"
        label="Responsabilidades"
        placeholder="Escolha..."
        v-model="form.stages"
        :list-data="listStages"/>

      <div class="commands col-12">
        <button-submit
          class="col-5"
          label="Salvar Usuário"
          :state="commands.submitState"
          :icon-save="commands.saveIcon"/>

        <button
          class="btn-ghost col-5 cancel-button"
          type="button"
          @click="closePanel">
          <icon-close />
          Cancelar
        </button>
      </div>
    </form>
  </section>
</template>

<script>
import ClickOutside from 'vue-click-outside'
import { Textbox, Password, Dropdown, ButtonSubmit } from '@/components/primitives'
import { IconCheck, IconClose, IconSave } from '@/components/primitives/icons'
import { AddUserWithPermissionAndOccupation } from '@/brain/record/user'
import { ListPermissions, ListOccupations, ListStages } from '../../NewUserHelper'
import { StageChecker } from '../../components'

export default {
  name: 'Occupation',
  components: {
    Textbox,
    Password,
    Dropdown,
    IconCheck,
    IconClose,
    ButtonSubmit,
    StageChecker
  },
  directives: {
    ClickOutside
  },
  data () {
    return {
      saveDisabled: false,
      form: {
        name: '',
        username: '',
        password: '',
        permission: '',
        occupation: '',
        stages: []
      },
      listPermissions: [],
      listOccupations: [],
      listStages: [],
      commands: {
        submitState: 'REPOSE',
        saveIcon: IconSave
      }
    }
  },
  mounted () {
    ListStages()
      .then((stageList) => {
        this.listStages = stageList
      })
    ListPermissions()
      .then((pPermissionList) => {
        this.listPermissions = pPermissionList
      })
    ListOccupations()
      .then((pOccupationList) => {
        this.listOccupations = pOccupationList
      })
  },
  methods: {
    submitForm () {
      this.commands.submitState = 'WAIT'

      const data = {
        name: this.form.name,
        username: this.form.username,
        password: this.form.password,
        occupation: this.form.occupation.value,
        permission: this.form.permission.value,
        responsabilities: this.form.stages
      }
      AddUserWithPermissionAndOccupation(data)
        .then((response) => {
          this.$emit('refresh-list')
          this.clearForm()
          this.commands.submitState = 'REPOSE'
          this.$parent.$emit('close', false)
        })
    },
    closePanel () {
      this.$parent.$emit('close', false)
    },
    clearForm () {
      this.form.name = ''
      this.form.username = ''
      this.form.password = ''
      this.form.occupation = ''
      this.form.permission = ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/record/user/right-panel/new-user/NewUser.vue